import Label from "../components/label/Label";


export const OrdersStatus = (status) => {
    switch (status) {
        case "WAT":
            return (
                <Label color={("" === 'banned' && 'error') || 'warning'}>WATING</Label>
            );
        case "COF":
            return (
                <Label color={("" === 'banned' && 'error') || 'info'}>CONFORM</Label>
            );
        case "PRE":
            return (
                <Label color={("" === 'banned' && 'error') || 'info'}>PREPARING</Label>
            );
        case "RDY":
            return (
                <Label color={("" === 'banned' && 'error') || 'primary'}>READY</Label>
            );
        case "OUT":
            return (
                <Label color={("" === 'banned' && 'error') || 'default'}>OUT FOR DELIVERY</Label>
            );
        case "DEL":
            return (
                <Label color={("" === 'banned' && 'error') || 'success'}>DELIVERED</Label>
            );
        case "CAN":
            return (
                <Label color={("" === 'banned' && 'error') || 'error'}>CANCELED</Label>
            );
        case "SCH":
            return (
                <Label color={("" === 'banned' && 'error') || 'secondary'}>SCHEDULED</Label>
            );
        default:
            return status;
    }
}

export const NumberFormatter = ({ number }) => {
    if (typeof number !== 'number') {
        return null; // You can add error handling or a loading state here if needed
    }

    const formattedNumber = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
    }).format(number);

    return <span>{formattedNumber}</span>;
}